import makeActionCreator from 'make-action-creator'

import {NAMESPACE} from './constants'

export const fetchUserData = makeActionCreator(NAMESPACE + '/fetchUserData')